export const frontend = [{
        id: 1,
        name: 'HTML',
        logo: "logos:html-5",
    },
    {
        id: 2,
        name: 'CSS',
        logo: "logos:css-3",
    },
    {
        id: 3,
        name: 'Javascript',
        logo: "logos:javascript",
    },
    {
        id: 4,
        name: 'React',
        logo: "logos:react",
    },
    {
        id: 5,
        name: 'BootStrap',
        logo: "logos:bootstrap",
    },
    {
        id: 6,
        name: 'Flutter',
        logo: "logos:flutter",
    }
];

export const backend = [{
        id: 1,
        name: 'NodeJs',
        logo: "logos:nodejs"
    },
    {
        id: 2,
        name: 'Php',
        logo: "logos:php"
    },
    {
        id: 3,
        name: 'Django',
        logo: "logos:django-icon"
    },
    {
        id: 4,
        name: 'Api',
        logo: "eos-icons:api"
    }
];

export const databases = [{
        id: 1,
        name: 'MySQL',
        logo: "logos:mysql"
    },
    {
        id: 2,
        name: 'MongoDb',
        logo: "logos:mongodb"
    },
    {
        id: 3,
        name: 'Neo4j',
        logo: "logos:neo4j"
    },
    {
        id: 4,
        name: 'Redis',
        logo: "logos:redis"
    }
];


export const languages = [{
        id: 1,
        name: "C++",
        logo: "bxl:c-plus-plus"
    },
    {
        id: 2,
        name: "Java",
        logo: "logos:java"
    },
    {
        id: 3,
        name: "Javascript",
        logo: "logos:javascript"
    },
    {
        id: 4,
        name: "Python",
        logo: "logos:python"
    },
    {
        id: 5,
        name: "Dart",
        logo: "logos:dart"
    },
    {
        id: 6,
        name: 'SQL',
        logo: "vscode-icons:file-type-sql"
    },
];

export const tools = [{
        id: 1,
        name: "GitHub",
        logo: "icon-park:github"
    },
    {
        id: 2,
        name: "GitLab",
        logo: "logos:gitlab"
    },
    {
        id: 3,
        name: "Postman",
        logo: "logos:postman-icon"
    },
    {
        id: 4,
        name: "VSCode",
        logo: "vscode-icons:file-type-vscode"
    },
    {
        id: 5,
        name: "Terminal",
        logo: "bxs:terminal"
    },
    {
        id: 6,
        name: "Code SandBox",
        logo: "ant-design:code-sandbox-circle-filled"
    },
]